import script from "./OpenParcels.vue?vue&type=script&setup=true&lang=js"
export * from "./OpenParcels.vue?vue&type=script&setup=true&lang=js"

import "./OpenParcels.vue?vue&type=style&index=0&id=5213daf9&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5213daf9"]])

export default __exports__